import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["code", "title", "actions", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import classNames from 'classnames';
import { DixuRow, DixuCol } from "../DixuGrid/DixuGrid";
import DixuImage from "../DixuImage/DixuImage";
import DixuText from "../DixuText/DixuText";
import DixuTitle from "../DixuTitle/DixuTitle";
import DixuButton from "../DixuButton/DixuButton";
import DixuContainer from "../DixuContainer/DixuContainer";
import AnglerIcon from "../../public/images/angler.svg";
const DixuHttpErrorInfo = _ref => {
  let {
      code,
      title,
      actions,
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-http-error-info', className);
  const mappedActions = actions.map((actionProps, index) => {
    return /*#__PURE__*/React.createElement(DixuButton, _objectSpread({
      key: index.toString(36),
      size: 'lg',
      shadow: actionProps.type === 'primary' ? '1' : undefined
    }, actionProps));
  });
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(DixuContainer, {
    maxWidth: "lg",
    height: "full-view",
    centerVertically: true,
    considerNav: true
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 20,
    xl: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    align: "middle",
    gutter: [32, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 15,
    xl: 9
  }, /*#__PURE__*/React.createElement(AnglerIcon, null)), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 15
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "5",
    color: "2-8",
    weight: "bold",
    block: true,
    className: "m-b-18"
  }, code), /*#__PURE__*/React.createElement(DixuTitle, {
    level: "1",
    font: "9",
    weight: "bold",
    margin: "0"
  }, title)), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    block: true,
    className: "m-b-6"
  }, children)), mappedActions.length > 0 && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xl: 24
  }, /*#__PURE__*/React.createElement(DixuButton.Group, null, mappedActions)))))))))));
};
DixuHttpErrorInfo.defaultProps = {
  code: undefined,
  actions: []
};
export default DixuHttpErrorInfo;